export default {"src":"/_next/static/media/lock.ff924905.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};